import React from 'react'
import Assets from '../../Assets/Assets';
import './Header.css';

const Header = () => {
  return (
    <div className='header-main'>
    <div className='header-section'>
     <div className='header-left-sec'>
    <p className='user-txt'>Hey, UserA</p>
    <p className='date-txt'>Monday, November 25,2024</p> 
     </div>
     <div className='header-right-sec'>
   <img src={Assets.notify_icon} alt="Notification" className='icon' />
   <img src={Assets.profile_icon} alt="Profile" className='icon'/>
     </div>
    </div>
    </div>
  )
}

export default Header